// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "vendors-node_modules_pnpm_ant-design_cssinjs-utils_1_1_3_react-dom_18_3_1_react_18_3_1__react-cdbb61") return "static/css/" + chunkId + ".css";
if (chunkId === "main") return "static/css/main.css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}